const getRuntimeConfig = () => {
    if (typeof window === 'undefined') {
        return {};
    }

    return window.__RUNTIME_CONFIG__ || {};
};

export const getRuntimeConfigValue = (key, fallback = undefined) => {
    const runtimeValue = getRuntimeConfig()[key];

    if (runtimeValue === undefined || runtimeValue === null || runtimeValue === '') {
        return fallback;
    }

    return runtimeValue;
};